module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./src/assets/lib/carouselengine/initcarousel-1.css
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./src/assets/lib/carouselengine/initcarousel-1.css
// module chunks = styles